var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入指令名称" },
            model: {
              value: _vm.searchData.name,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "name", $$v)
              },
              expression: "searchData.name"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择设备类型"
              },
              model: {
                value: _vm.searchData.typeCode,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "typeCode", $$v)
                },
                expression: "searchData.typeCode"
              }
            },
            _vm._l(_vm.droplist, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.code }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择指令类型", clearable: "" },
              model: {
                value: _vm.searchData.type,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "type", $$v)
                },
                expression: "searchData.type"
              }
            },
            _vm._l(_vm.typelist, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addFun }
            },
            [_vm._v("新增")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "45" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "平板手控器选中图标" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.selectedImage
                      ? [
                          _c(
                            "a",
                            { attrs: { href: "#" } },
                            [
                              _c("el-image", {
                                staticClass: "image",
                                attrs: {
                                  src: scope.row.selectedImage,
                                  alt: "",
                                  "preview-src-list": _vm.imageSrcList
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setImageList(
                                      scope.row.selectedImage
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "平板手控器未选中图标" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.image
                      ? [
                          _c(
                            "a",
                            { attrs: { href: "#" } },
                            [
                              _c("el-image", {
                                staticClass: "image",
                                attrs: {
                                  src: scope.row.image,
                                  alt: "",
                                  "preview-src-list": _vm.imageSrcList
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.setImageList(scope.row.image)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "移动端未选中图标" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.phoneImage
                      ? [
                          _c("el-image", {
                            staticClass: "image",
                            attrs: {
                              src: scope.row.phoneImage,
                              alt: "",
                              "preview-src-list": _vm.imageSrcList
                            },
                            on: {
                              click: function($event) {
                                return _vm.setImageList(scope.row.phoneImage)
                              }
                            }
                          })
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "移动端选中图标" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.phoneSelectedImage
                      ? [
                          _c("el-image", {
                            staticClass: "image",
                            attrs: {
                              src: scope.row.phoneSelectedImage,
                              alt: "",
                              "preview-src-list": _vm.imageSrcList
                            },
                            on: {
                              click: function($event) {
                                return _vm.setImageList(
                                  scope.row.phoneSelectedImage
                                )
                              }
                            }
                          })
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "260", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "编辑", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to:
                            "/instructions/instructionslistdetail/" +
                            scope.row.id
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { title: "多国语言", size: "mini" } },
                          [_vm._v("多国语言")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "500px",
            visible: _vm.newadd,
            "before-close": _vm.closeRefund,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "180px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "平板手控器选中图标", prop: "selectedImage" }
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        "http-request": _vm.fnUploadRequest,
                        action: "string",
                        "before-remove": _vm.beforeRemove,
                        "on-remove": _vm.handleOnRemove,
                        "on-success": _vm.onsuccess,
                        "on-change": _vm.handleChangePic,
                        "show-file-list": false,
                        accept: "_US1"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _vm._v(" "),
                      _vm.addData.selectedImage != ""
                        ? _c("div", { staticClass: "imgBox" }, [
                            _c("img", {
                              staticClass: "upload-img",
                              attrs: {
                                src: _vm.addData.selectedImage,
                                alt: "",
                                width: "50"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "平板手控器未选中图标", prop: "image" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        "http-request": _vm.fnUploadRequest,
                        action: "string",
                        "before-remove": _vm.beforeRemove,
                        "on-remove": _vm.handleOnRemove,
                        "on-success": _vm.onsuccess2,
                        "on-change": _vm.handleChangePic,
                        "show-file-list": false,
                        accept: "_US1"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _vm._v(" "),
                      _vm.addData.image != ""
                        ? _c("div", { staticClass: "imgBox" }, [
                            _c("img", {
                              staticClass: "upload-img",
                              attrs: {
                                src: _vm.addData.image,
                                alt: "",
                                width: "50"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "移动端器选中图标",
                    prop: "phoneSelectedImage"
                  }
                },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        "http-request": _vm.fnUploadRequest,
                        action: "string",
                        "before-remove": _vm.beforeRemove,
                        "on-remove": _vm.handleOnRemove,
                        "on-success": _vm.onsuccess3,
                        "on-change": _vm.handleChangePic,
                        "show-file-list": false,
                        accept: "_US1"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _vm._v(" "),
                      _vm.addData.phoneSelectedImage != ""
                        ? _c("div", { staticClass: "imgBox" }, [
                            _c("img", {
                              staticClass: "upload-img",
                              attrs: {
                                src: _vm.addData.phoneSelectedImage,
                                alt: "",
                                width: "50"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "移动端器未选中图标", prop: "phoneImage" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        "http-request": _vm.fnUploadRequest,
                        action: "string",
                        "before-remove": _vm.beforeRemove,
                        "on-remove": _vm.handleOnRemove,
                        "on-success": _vm.onsuccess4,
                        "on-change": _vm.handleChangePic,
                        "show-file-list": false,
                        accept: "_US1"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _vm._v(" "),
                      _vm.addData.phoneImage != ""
                        ? _c("div", { staticClass: "imgBox" }, [
                            _c("img", {
                              staticClass: "upload-img",
                              attrs: {
                                src: _vm.addData.phoneImage,
                                alt: "",
                                width: "50"
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.sort,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "sort", $$v)
                      },
                      expression: "addData.sort"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "指令名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.name,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "name", $$v)
                      },
                      expression: "addData.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "蓝牙命令", prop: "bluetooth" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.bluetooth,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "bluetooth", $$v)
                      },
                      expression: "addData.bluetooth"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "wifi指令", prop: "command" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.command,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "command", $$v)
                      },
                      expression: "addData.command"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "按摩力度", prop: "intensity" } },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.addData.intensity,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "intensity", $$v)
                      },
                      expression: "addData.intensity"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设备类型", prop: "typeCode" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.addData.typeCode,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "typeCode", $$v)
                        },
                        expression: "addData.typeCode"
                      }
                    },
                    _vm._l(_vm.droplist, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "指令类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.addData.type,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "type", $$v)
                        },
                        expression: "addData.type"
                      }
                    },
                    _vm._l(_vm.typelist, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "说明文字", prop: "remarks" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      maxlength: "256",
                      placeholder: "最多不能超过256个字符"
                    },
                    model: {
                      value: _vm.addData.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "remarks", $$v)
                      },
                      expression: "addData.remarks"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "版本", prop: "description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      id: "description",
                      placeholder: "请输入版本号"
                    },
                    model: {
                      value: _vm.addData.description,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "description", $$v)
                      },
                      expression: "addData.description"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否新增程序", prop: "isNewProgram" } },
                _vm._l(_vm.isNewProgramArr, function(item, index) {
                  return _c(
                    "el-radio",
                    {
                      key: index,
                      attrs: { label: item.value },
                      model: {
                        value: _vm.addData.isNewProgram,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "isNewProgram", $$v)
                        },
                        expression: "addData.isNewProgram"
                      }
                    },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "编辑"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }